import { lazy } from 'react';
import { withSuspense } from '@/hocs/withSuspense';

export const PageNotFoundLazy = withSuspense(lazy(() => import('./404.page')));
